"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCopyProductTreeTitle = void 0;
const getCopyProductTreeTitle = (catalogName) => `${catalogName} Custom Ontology`;
exports.getCopyProductTreeTitle = getCopyProductTreeTitle;
